/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import gql from 'graphql-tag';

export const OBJECT_TYPE_ATTRIBUTES_QUERY = gql`
  query ObjectTypeAttributes($type: SearchType!, $context: AttributesContext!) {
    objectType(name: $type) {
      attrs(context: $context) {
        name
        displayName
        filterable
        customAttributeType
        isMapping
      }
    }
  }
`;
